// extracted by mini-css-extract-plugin
export default {"point":"PointMarker_point__GO6Dr","xbtd22-j":"PointMarker_xbtd22-j__n+PqN","xbtd22-n":"PointMarker_xbtd22-n__kzSkm"};